import { ChangeDetectionStrategy, Component } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { SharedAppComponent } from '../../../shared/src/lib/shared-app.component';
import { ToastNotificationsComponent } from '@serene-dev/toast-notifications';
import { VersionNoComponent } from '../../../shared/src/lib/components/version-no/version-no.component';
import { UserHelperComponent } from '../../../shared/src/lib/components/components';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastNotificationsComponent, VersionNoComponent, UserHelperComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent extends SharedAppComponent {
  constructor() {
    super();
    // this.menuF.setMenu(this.appService.adminMenu());
  }
  override ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
